<template>
  <transition name="fade">
    <div class="mask" v-show="isShow" ref="maskEl" :style="maskStyle" @mousedown="closeMask"></div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isShow: false,
      maskStyle: {}
    };
  },
  computed: {
    ...mapGetters([
      "Window_Size",
      "Tool_Size",
      "MaterialPane_Size",
      "SetPanel_Size",
      "TopNav_Size",
      "TimeLine_size",
      "BgOperation"
    ])
  },
  watch: {
    BgOperation: {
      handler(val) {
        this.toggleMask({
          isShow: val === "swap"
        });
      }
    }
  },

  methods: {
    toggleMask({ isShow = false } = {}) {
      this.isShow = isShow;
      if (isShow) {
        this.setMaskSzie();
        this.$store.commit('materialArea/setShelters', [2,7]);
      } else {
        this.$store.commit('materialArea/setShelters', [0,1,2,3,4,5,6,7]);
      }
    },
    setMaskSzie() {
      let {
        Window_Size,
        SetPanel_Size,
        MaterialPane_Size,
        Tool_Size,
        TopNav_Size
      } = this;
      this.maskStyle.width =
        Window_Size.width - SetPanel_Size.width + 23 + "px";
      this.maskStyle.height = Window_Size.height + "px";
      this.maskStyle.left = this.MaterialPane_Size.width + 'px';
    },
    closeMask() {
      this.$store.commit("save_BgOperation", "add");
    }
  }
};
</script>

<style lang="scss" scoped>
.mask {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(248, 248, 248, 0.75);
}
</style>



// WEBPACK FOOTER //
// src/components/Popups-z/maskBgSwap.vue